import TileLayer from 'ol/layer/WebGLTile';
import XYZSource from 'ol/source/XYZ';
import {mapHost, mapSource} from "@/olMap/layer/GoogleMap";

export default class GoogleMapSatelliteRoad extends TileLayer {
    static get layerName() {
        return 'google-map-satellite-road';
    }

    constructor(opt_options) {
        let google = ((opt_options || {}).mapSource || mapSource) === "google";
        super(Object.assign({
            name: GoogleMapSatelliteRoad.layerName,
            source: new XYZSource({
                crossOrigin: 'anonymous',
                url: google ? `${mapHost}/satellite-road/{z}/{x}/{y}`
                    : "https://wprd01.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=1&style=8",
            })
        }, opt_options));
    }
}
